import React from "react";
import Headers from "./Headers";
import About from "./About";
import Contact from "./Contact";
import Services from "./Services";
import Courses from "./Courses";
import Testimonials from "./Testimonials";

function ParentPage() {
  return (
    <div>
      <Headers />

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="courses">
        <Courses />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section>

      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default ParentPage;
